// src/lib/supabaseClient.ts
import { createClient } from '@supabase/supabase-js'

// if you’re on Vite, env vars need the VITE_ prefix:
const supabaseUrl   = import.meta.env.VITE_SUPABASE_URL!
const supabaseKey   = import.meta.env.VITE_SUPABASE_ANON_KEY!

export const supabase = createClient(supabaseUrl, supabaseKey)
